import { Injectable } from "@angular/core";

const GROUP_DEFAULT_ROUTE: Record<string, string> = {
  "/SOLUTION": "/solution/company",
  "/ADMINISTRATION": "/administration/general-parameters",
  "/PAYMENT": "/payment/list",
  "/SUPPORT": "/manage-ticket",
  "/ORDER": "/order/list",
  "/DELIVERY": "/delivery/parcel/list",
  "/VOUCHER": "/voucher/list",
  "/MESSAGING": "/analytics-chat",
};

const GROUP_PRIORITY: string[] = [
  "/MESSAGING",
  "/ORDER",
  "/VOUCHER",
  "/DELIVERY",
  "/SUPPORT",
  "/PAYMENT",
  "/ADMINISTRATION",
  "/SOLUTION",
];
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private readonly authService: AuthService,
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    // Force login if not authenticated

    if (!this.authenticated) {
      // Store the target URL in sessionStorage
      sessionStorage.setItem('redirectAfterLogin', state.url);
      await this.keycloak.login();
      return false;
    }

    let currentRoute = route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    // Check required roles
    const requiredRoles = currentRoute.data["roles"];
    const hasAccess =
      !Array.isArray(requiredRoles) || requiredRoles.length === 0
        ? true
        : requiredRoles.every((role) => this.roles.includes(role));

    // If access is allowed, continue
    if (hasAccess) return true;

    // If user has no access, redirect safely
    // Try redirect to previously saved URL if any
    const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
    if (redirectUrl) {
      sessionStorage.removeItem("redirectAfterLogin");
      this.router.navigateByUrl(redirectUrl);
      return false;
    }

    // Otherwise, fallback to first available group landing
    const userGroups = this.authService.getUserGroups();
    const targetGroup = GROUP_PRIORITY.find((group) =>
      userGroups.includes(group),
    );

    const targetRoute =
      (targetGroup && GROUP_DEFAULT_ROUTE[targetGroup]) || "/analytics-chat";

    this.router.navigateByUrl(targetRoute);
    return false;
  }
}
